// extracted by mini-css-extract-plugin
module.exports = {"line":"SortableAllowanceItemTable__line--1I1nJ","icon":"SortableAllowanceItemTable__icon--1-r-5"};